import React from "react"
import Heading from "../../common/Heading"
import "./price.css"
import PriceCard from "./PriceCard"

const Price = () => {
  return (
    <section className='price padding'>
      <div className='container'>
        <Heading
          title='How We Can Help You'
          subtitle='From property search to full custom builds, choose the level of service that fits your needs. Request a build quote or browse our listings.'
        />
        <PriceCard />
      </div>
    </section>
  )
}

export default Price
